import React, { FC, ReactNode, DOMAttributes } from 'react';

import styled from '@emotion/styled';
import {
  compose,
  typography,
  space,
  color,
  variant,
  TypographyProps,
  SpaceProps,
  ColorProps,
  LayoutProps,
  ComponentsType
} from '@lucid/theme';

export type TextListTagTypes = 'ul' | 'ol';
export const textListTagTypes = ['ul', 'ol'];

export interface TextListProps extends
  ColorProps,
  LayoutProps,
  SpaceProps,
  TypographyProps,
  DOMAttributes<HTMLElement> {
  /** Sets the HTML tag for the TextList component. */
  as?: TextListTagTypes;
  /** Allows the component to get additional styles. */
  className?: string;
  /** Children passed to the TextList component. */
  children?: ReactNode;
  /** The available variants for the TextList component. */
  variant?: ComponentsType['Typography'];
}

const textListStyleProps = compose(space, typography, color);

const StyledTextList: FC<TextListProps> = styled.ul(
  variant({
    variants: {
      scale: 'tyopgraphy',
      defaultVariant: {}
    }
  }),
  {
    label: 'textList'
  },
  textListStyleProps
);

const TextList: FC<TextListProps> = ({ as, children, className, variant, ...rest }) => (
  <StyledTextList {...rest} as={as} className={className} variant={variant}>
    {children}
  </StyledTextList>
);

export { TextList };
export default TextList;
